"use client";

import { useForm } from "react-hook-form";
import { useState } from "react";
import { toast } from "sonner";
import type { ContactFormData } from "@/types/contact";

export function useContactForm() {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors, isSubmitting },
  } = useForm<ContactFormData>({
    defaultValues: {
      fullName: "",
      companyName: "",
      businessEmail: "",
      phoneNumber: "",
      country: "",
      serviceRequired: "",
      productCategory: "",
      estimatedQuantity: "",
      message: "",
      referenceFile: null,
      privacyPolicy: false,
    },
    mode: "onTouched",
  });

  const handleFileSelect = (file: File | null) => {
    setSelectedFile(file);
    console.log("Selected file:", file);
  };

  const onSubmit = (data: ContactFormData) => {
    const submissionData = {
      ...data,
      referenceFile: selectedFile,
    };

    console.log("Contact Form Submission:", submissionData);

    toast.success("Thank you! We'll contact you shortly.", {
      description: "Your inquiry has been received. Our team will reach out within 24 hours.",
      duration: 5000,
    });

    reset();
    setSelectedFile(null);
  };

  const onError = () => {
    toast.error("Please fix the highlighted fields.", {
      description: "Some required information is missing or incorrect.",
      duration: 4000,
    });
  };

  return {
    register,
    handleSubmit,
    control,
    errors,
    isSubmitting,
    selectedFile,
    handleFileSelect,
    onSubmit,
    onError,
  };
}